import { Spinner } from '@repo/ui'
import { observer } from 'mobx-react-lite'
import { useParams } from 'react-router-dom'

import { EditTriviaList } from './edit-trivia-list'
import { useQuerySystemTriviaList } from '../queries/useQuerySystemTriviaList'
import { useUpdateSystemTriviaList } from '../queries/useUpdateSystemTriviaList'

export const SYSTEM_TRIVIA_LIST_IMAGES_FOLDER = 'system_trivia_list_images'

interface RouteParams {
  listId: string
}

export const EditTriviaListRouteAdmin = observer(() => {
  const { listId } = useParams<RouteParams>()
  const { data, isLoading, isSuccess } = useQuerySystemTriviaList(listId)

  const { isLoading: isSaving, mutate: updateSystemTriviaList } = useUpdateSystemTriviaList({
    listId
  })

  if (isLoading) return <Spinner />

  if (!isSuccess) return null

  return (
    <EditTriviaList
      baseUrl='/admin/'
      data={data}
      imageStorageFolder={SYSTEM_TRIVIA_LIST_IMAGES_FOLDER}
      isSaving={isSaving}
      pageTitle='Edit Trivia List (Admin)'
      updateTriviaList={updateSystemTriviaList}
    />
  )
})
